// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import VueAnalytics from 'vue-analytics'

// Load css modules
import './css/flexboxgrid.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'

Vue.use(VueAnalytics, {
  id: 'UA-65390488-4',
  router
})

Vue.config.productionTip = false
Vue.use(VueResource);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js